import { Component, OnInit } from '@angular/core';

import {
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import { ICollaborator } from 'src/app/interfaces/collaborator';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { IUsersystem } from '../../interfaces/usersystem';
import { OperadorService } from '../../services/operador.service';

@Component({
  selector: 'app-collaborators',
  templateUrl: './collaborators.component.html',
  styleUrls: ['./collaborators.component.scss'],
  host: { 'class': 'wrapper-settings' }
})
export class CollaboratorsComponent implements OnInit {

  public operador: IUsersystem

  public loading: boolean
  public loadingDetail: boolean = false
  public changeDetail: boolean

  public collaboratorsFrm: FormGroup

  public status: FormControl
  public nome: FormControl
  public sobrenome: FormControl
  public cpf: FormControl
  public usuario: FormControl
  public new_senha: FormControl
  public sc_tipo: FormControl
  public sc_pedido_empacotador: FormControl
  public sc_pedido_entregador: FormControl

  public optionOpen: boolean = false
  public optionTimeout: any = null

  public loadingDelete: boolean = false
  public showConfirmDelete: boolean = false
  public isDeleteCollaborators: boolean = false

  public openid: number = null
  public open: boolean = false

  public collaborators: ICollaborator[]
  public collaborator: ICollaborator

  constructor(private _operadorService: OperadorService) {
    this.operador = this._operadorService.getOperador()

    this.collaborator = {
      idoperador: -1
    }
  }

  ngOnInit(): void {
    this.loading = false
    this.loadingDetail = false
    this.changeDetail = false

    this.createFormControls()
    this.createForm()

    this.find()
  }

  createFormControls() {
    this.status = new FormControl('')
    this.nome = new FormControl('')
    this.sobrenome = new FormControl('')
    this.cpf = new FormControl('')
    this.usuario = new FormControl('')
    this.new_senha = new FormControl('')
    this.sc_tipo = new FormControl('')
    this.sc_pedido_empacotador = new FormControl('')
    this.sc_pedido_entregador = new FormControl('')
  }

  createForm() {
    this.collaboratorsFrm = new FormGroup({
      status: this.status,
      nome: this.nome,
      sobrenome: this.sobrenome,
      cpf: this.cpf,
      usuario: this.usuario,
      new_senha: this.new_senha,
      sc_tipo: this.sc_tipo,
      sc_pedido_empacotador: this.sc_pedido_empacotador,
      sc_pedido_entregador: this.sc_pedido_entregador
    })
  }

  find() {
    this.loading = true
    this._operadorService.find().subscribe(res => {
      if (res.success) {
        this.collaborators = res.operadores
      }

      this.loading = false
    })
  }

  toggleOptions(): void {
    this.optionOpen=!this.optionOpen

    this.clearOptions()
  }

  hideOptions(): void {
    if (this.optionOpen) {
      if (this.optionTimeout) clearTimeout(this.optionTimeout)

      this.optionTimeout = setTimeout(()=>{
        this.optionOpen = false
      }, 2000)
    }
  }

  clearOptions(): void {
    if (this.optionTimeout) clearTimeout(this.optionTimeout)
  }


  showDeleteCollaborators() {
    this.isDeleteCollaborators = !this.isDeleteCollaborators
    if (this.isDeleteCollaborators) {
      this.toggleOptions()
    }
  }

  onDeleteCollaborators() {
    Swal.fire({
      title: 'Você realmente excluir?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        this.loadingDelete = true

        this.loadingDelete = false
      }
    })
  }

  cancelEdit() {
    //reaload
    this.changeDetail = false
  }

  updateStatus() {
    this.collaborator.status = this.status.value ? 'A' : 'I'
    if (this.collaborator.idoperador > 0) {
      this._operadorService.patch(this.collaborator.idoperador, {
        status: this.status.value ? 'A' : 'I'
      }).subscribe(res=>{

      })
    }
  }

  newCollaborator() {
    document.getElementById('detailCollaborators').scrollTop = 0;
    this.showConfirmDelete = false
    this.isDeleteCollaborators = false
    this.open = true
    this.changeDetail = false

    this.collaborator = {
      idoperador: -1
    }

    this.status.setValue(false)
    this.nome.setValue(null)
    this.sobrenome.setValue(null)
    this.cpf.setValue(null)
    this.usuario.setValue(null)
    this.new_senha.setValue(null)
    this.sc_tipo.setValue('O')
    this.sc_pedido_empacotador.setValue(null)
    this.sc_pedido_entregador.setValue(null)

    this.openid = null
  }

  openDetail(collaborator: ICollaborator, i: number) {
    document.getElementById('detailCollaborators').scrollTop = 0;

    this.showConfirmDelete = false
    this.isDeleteCollaborators = false
    this.open = true
    this.changeDetail = false
    this.collaborator = collaborator

    this.status.setValue(this.collaborator.status == 'A')
    this.nome.setValue(this.collaborator.nome)
    this.sobrenome.setValue(this.collaborator.sobrenome)
    this.cpf.setValue(this.collaborator.cpf)
    this.usuario.setValue(this.collaborator.usuario)
    this.new_senha.setValue(null)
    this.sc_tipo.setValue(this.collaborator.sc_tipo)
    this.sc_pedido_empacotador.setValue(this.collaborator.sc_pedido_empacotador == 'S')
    this.sc_pedido_entregador.setValue(this.collaborator.sc_pedido_entregador == 'S')

    this.openid = i
  }

  onChangeDetail() {
    this.changeDetail = true
  }

  closeDetail() {
    this.open = false
    this.openid = null
  }

  saveError(err) {
    if (err && err == 'usuario_already_exist') {
      Swal.fire("Ops!", "O usuário já existente!", "error")
    } else {
      Swal.fire("Ops!", "Ocorreu um erro ao tentar salvar.", "error")
    }
  }

  saveComplete() {
    Swal.fire("Salvo!", "O colaborador foi salvo", "success")
  }

  saving() {
    Swal.fire({
      title: "Salvando...",
      icon: "info",
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false
    });
  }

  collaboratorValid() {
    let has = true

    let msg = []

    if ((this.nome.invalid && (this.nome.dirty || this.nome.touched)) || this.nome.value == '' || this.nome.value == undefined  || this.nome.value == null) {
      msg.push('Você precisa preencher o nome do colaborador!');
      has = false
    }

    if ((this.usuario.invalid && (this.usuario.dirty || this.usuario.touched)) || this.usuario.value == '' || this.usuario.value == undefined || this.usuario.value == null) {
      msg.push('Você precisa preencher um usuário para o colaborador!');
      has = false
    }

    if (this.collaborator.idoperador == -1) {
      if ((this.new_senha.invalid && (this.new_senha.dirty || this.new_senha.touched)) || this.new_senha.value == '' || this.new_senha.value == undefined || this.new_senha.value == null) {
        msg.push('Você precisa preencher a senha para o colaborador!');
        has = false
      }
    }

    if (msg.length > 0) {
      Swal.fire("Ops!", msg.join("<br>"), "error");
    }

    return has
  }

  onSubmit() {
    if (this.collaboratorValid()) {

      let data = {
        status: this.status.value ? 'A' : 'I',
        nome: this.nome.value,
        sobrenome: this.sobrenome.value,
        cpf: this.cpf.value,
        usuario: this.usuario.value,
        new_senha: this.new_senha.value,
        sc_tipo: this.sc_tipo.value,
        sc_pedido_empacotador: this.sc_pedido_empacotador.value ? 'S' : 'N',
        sc_pedido_entregador: this.sc_pedido_entregador.value ? 'S' : 'N'
      }

      if (this.collaborator.idoperador == -1) {
        this.storeCollaborator(data)
      } else {
        this.patchCollaborator(data)
      }
    }
    return false
  }

  storeCollaborator(data) {
    this._operadorService.store(data).subscribe(res => {
      this.resCollaborator(res)

      if (res['idoperador']) {
        data['idoperador'] = res['idoperador']
        this.collaborator.idoperador = res['idoperador']
        this.collaborators.push(data)
        this.openid = this.collaborators.length - 1
      }

    }, error => {
      this.saveError(error)

    })
  }

  patchCollaborator(data) {
    this._operadorService.patch(this.collaborator.idoperador, data).subscribe(res => {
      this.resCollaborator(res)

      if (res['success']) {
        for(let j in data) {
          this.collaborators[this.openid][j] = data[j]
        }
      }

    }, error => {
      this.saveError(error)

    })
  }

  resCollaborator(res) {
    if (res['success']) {

      this.changeDetail = false
      this.saveComplete()

    } else {
      this.saveError(res['error'])
    }
  }

}
